import React, { useEffect, useState } from "react";
import { FaApple } from "react-icons/fa";
import axios from "../axios/index";
import { toast } from "react-toastify";

const ApplePay = ({
  handleOnPaymentAuthorize,
  amount,
  currencyCode,
  countryCode,
  merchantIdentifier,
  merchantName,
  roomId,
}) => {
  const [applePayAvailable, setApplePayAvailable] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    // Safely check if Apple Pay is available without causing errors
    const hasApplePay =
      typeof window !== "undefined" && window.hasOwnProperty("ApplePaySession");

    console.log("Apple Pay Session", window.ApplePaySession, hasApplePay);

    if (hasApplePay) {
      // Only check for active cards if ApplePaySession exists
      try {
        window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier)
          .then((canMakePaymentsWithActiveCard) => {
            console.log(
              canMakePaymentsWithActiveCard,
              "in here can make payyment"
            );
            setApplePayAvailable(canMakePaymentsWithActiveCard);
          })
          .catch((error) => {
            console.error("Error checking Apple Pay capability:", error);
            setApplePayAvailable(false);
          });
      } catch (error) {
        console.error("Error checking Apple Pay:", error);
        setApplePayAvailable(false);
      }
    } else {
      console.log("Apple Pay is not available in this browser/device");
      setApplePayAvailable(false);
    }
  }, [merchantIdentifier]);

  const startApplePaySession = async () => {
    setIsDisabled(true);
    // Safety check again before starting session
    // if (!applePayAvailable) {
    //   console.error("Apple Pay is not available");
    //   return;
    // }

    try {
      const paymentRequest = {
        countryCode,
        currencyCode,
        supportedNetworks: ["visa", "masterCard"],
        merchantCapabilities: ["supports3DS"],
        total: {
          label: merchantName,
          amount: amount.toString(),
        },
      };

      const session = new window.ApplePaySession(3, paymentRequest);

      session.onvalidatemerchant = async (event) => {
        try {
          const response = await axios.post(
            `/${roomId}/orders/apple-pay-session`
          );
          const merchantSession = response.data;

          setIsDisabled(false);
          session.completeMerchantValidation(merchantSession);
        } catch (error) {
          setIsDisabled(false);
          console.error("Merchant validation failed:", error);
          session.abort();
        }
      };

      session.onpaymentauthorized = async (event) => {
        try {
          setIsDisabled(false);

          await handleOnPaymentAuthorize({
            is_apple_pay: 1,
            apple_pay_token: event.payment.token,
          });
          session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
        } catch (err) {
          setIsDisabled(false);
          toast.error(err.message);
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          console.error("Payment processing failed:", err);
        }
      };

      session.oncancel = (event) => {
        setIsDisabled(false);
        console.log("Apple Pay session cancelled", event);
      };

      session.begin();
    } catch (error) {
      setIsDisabled(false);
      console.error("Error starting Apple Pay session:", error);
    }
  };

  return (
    <div
      className="text-center"
      style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <button
        className="apple-pay-button order-btn"
        style={{
          opacity: isDisabled ? "60%" : "100%",
          backgroundColor: "#000",
          color: "#fff",
          width: "100%",
          paddingRight: "17px",
        }}
        onClick={startApplePaySession}
        type="button"
        disabled={isDisabled}
      >
        <div
          style={{
            opacity: isDisabled ? "90%" : "100%",
          }}
        >
          <FaApple size={18} /> Pay
        </div>
      </button>
    </div>
  );
};

export default ApplePay;
